import React from 'react';
import './App.css'; 
import logo from './logo.png';
import ContactForm from './ContactForm';
import instagramLogo from './instagram.png'; // Ensure you have an Instagram logo image
import etsyLogo from './etsy.png'; // Ensure you have an Etsy logo image

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} alt="Logo" className="App-logo"></img> 
        <h1>Welcome to G & T Estate Services</h1>
        <button onClick={() => window.open('https://www.instagram.com/gtestateservicesltd/', '_blank')}>
      <img src={instagramLogo} alt="instagram" style={{height: "60px", width: "auto"}} />
      </button>
    <button onClick={() => window.open('https://www.estatesales.net/companies/CO/Denver/80203/166514', '_blank')}>
    <a href="https://www.estatesales.net/">
  <img src="https://www.estatesales.net/assets/images/logos/dark100.png" width="385" height="65" alt="EstateSales.NET" />
</a>
      </button>
    <button onClick={() => window.open('https://www.etsy.com/shop/gtvintageco/?etsrc=sdt', '_blank')}>
    <img src={etsyLogo} alt="etsy" style={{height: "60px", width: "auto"}} />
      </button>
      </header>
      <main>
        <section className="features">
          <h2>About Us</h2>
          <div className="feature">
          
            <p>With well over a decade in Denver's estate sale scene, we bring big company know-how with a genuine personal touch.  We understand that this process can be daunting, and our main focus is on making these transitions as easy as possible on our clients. We offer flexible terms, a wealth of knowledge, and real local experience. </p>
          </div>
      
        </section>
        <section className="contact">
          <h2>Contact Us</h2>
          <div className="contact-info">
          <p>If you have any questions, feel free to reach out!
            <br />
            <strong>Gracie:</strong>
            <br /> 970-302-7444
            <br />          
            <strong>Tyler:</strong>
            <br /> 720-254-4907
            <br />
          </p>
          </div>
          
         <div className="App">
        <ContactForm />
         </div>
        </section>
        <section className="process">
        <h2>Estate Sale Process</h2>
        <div className="f&q-info">
          <h2>To Start</h2>
          <p>We like to start by setting a time to do a walkthrough of the property. These walkthroughs are typically conducted on Tuesdays and Wednesdays but we are flexible if those days don’t work for you. During the walkthrough we will go through the house with you taking reference photos of any items potentially for sale. Afterwards we will sit down with you and go over your timeline and answer any questions you may have. Our typical contract is a 60/40 split in favor of the client. There are no minimums or set up fees, however, we do split the minimal credit card fees which on average is 2.6%.</p>
          <h3>Before the Sale (Prepping, Pricing, Advertising)</h3>
          <p>Once a sale date has been selected we will then come in to prep and price the house. This is typically done Tuesday/Wednesday the week prior to the selected sale date to make sure there is ample advertising time and to allow for extra prepping/pricing time if needed. During the prepping process we will bring in tables and stage all the items that are for sale. If any personal items are found we will notify you and set them aside. Once everything is staged, we take photos of all the items for sale in situ and compile them into a sales listing. We advertise on EstateSales.net, Instagram, Facebook, and Nextdoor. This sales listing will also be shared with you to make sure no photos were taken of items that are not for sale and for you to share with family, friends, etc.  We price items according to liquidation value. Meaning, we look items up and price them at 50% of the most current SOLD prices. Please note that some items may be priced above the liquidation value based on desirability or lower than the liquidation value based on the condition of the item. We are more than happy to explain any pricing questions during this process.</p>
          <h3>During the Sale Day</h3>
          <p>We typically host 3 day sales on the property Thursday-Saturday 9am-3pm. Depending on the amount of items we can do 2 day sales or 4 day sales as well. In rare cases of extremely high volume we can do a sale in two phases over two weekends. During a typical 3 day sale the 1st day will be full price, the 2nd day will be 25% off, and the last day will be 50% off. This, along with the liquidation value pricing, helps to ensure that we can sell as many of the items as possible. All items sold will be put into general categories for the final accounting.</p>
          <h3>After the Sale</h3>
          <p>Once the sale has concluded all items are remitted back to the client to be dealt with as the client sees fit. We do not personally do any Haul Aways as we see this as a conflict of interest. We do, however, recommend certain Haul Away companies such as 2 Chicks and a Dolly who have helped many of our clients with post sale services. The final accounting is typically done the tuesday/wednesday after the sale is concluded. At this point you will receive an email with the breakdown of the accounting and a check mailed to the proceeds address stated in the contract.</p>
          </div>
        </section>

      </main>
      <footer>
        <p>&copy; 2025 G&T Estate Services</p>
      </footer>
    </div>
  );
}

export default App;
